/**
 * The "Select all that apply" follow-ups revealed by `open_liens_judgments`.
 * When that gating box is unticked these must be cleared too — otherwise a
 * borrower can carry `tax_liens: true` while answering "no open liens".
 * Shared by the create-loan Borrowers section and the Add Borrower sidebar.
 */
export const OPEN_LIENS_DETAIL_FIELDS = [
  "charge_offs",
  "tax_liens",
  "financial_judgements",
  "pending_litigation",
];

/**
 * `onChange` handler for the gating checkbox: clears the detail fields when it
 * is unticked. `change` is react-final-form's `form.change`; `prefix` is the
 * borrower's path within form values (omit when values ARE the borrower).
 */
export const clearOpenLiensDetails = (change, prefix) => (checked) => {
  if (checked) return;
  OPEN_LIENS_DETAIL_FIELDS.forEach((field) =>
    change(prefix ? `${prefix}.${field}` : field, undefined),
  );
};
